import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Visibility from '@material-ui/icons/Visibility';
import common from '@material-ui/core/colors/common';
import { routePage } from '../store/route-page';
import { FILTERS, filter } from '../store/filter';

class MapFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { anchorEl: undefined };
    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  onClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  onClose() {
    this.setState({ anchorEl: undefined });
  }

  onSelect(newFilter) {
    filter.set(newFilter);
    this.setState({ anchorEl: undefined });
  }

  render() {
    const { t } = this.props;
    const { anchorEl } = this.state;
    const currentFilter = filter.get();
    const unordered = routePage.unorderedAddresses;
    const ordered = routePage.orderedAddresses;
    const count = {
      [FILTERS.ALL]: unordered.length + ordered.length,
      [FILTERS.UNORDERED]: unordered.length,
      [FILTERS.ORDERED]: ordered.length,
      [FILTERS.NOT_GEOLOCATED]: [...unordered, ...ordered].filter(address => address.notGeolocated).length,
    };
    return (
      <React.Fragment>
        <Tooltip title={t('buttons.changeAddressesToShow')}>
          <Button variant="contained" size="small" style={{ backgroundColor: common.white }} onClick={this.onClick}>
            <Visibility style={{ marginRight: '8px' }}/>
            {t(`mapFilter.${currentFilter}`, { count: count[currentFilter] })}
          </Button>
        </Tooltip>
        <Menu id="filter-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.onClose}>
          {Object.keys(FILTERS).map(key => <MenuItem key={key} selected={key === currentFilter} dense onClick={() => this.onSelect(key)}>
              {t(`mapFilter.${key}`, { count: count[key] })}
            </MenuItem>)}
        </Menu>
      </React.Fragment>
    );
  }
}

MapFilter.propTypes = { t: PropTypes.func.isRequired };

export default withNamespaces()(observer(MapFilter));



// WEBPACK FOOTER //
// ./src/components/MapFilter.js